// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "client/" + {"1474":"my-posts-page-modals","4061":"post-actions"}[chunkId] + ".chunk.min.css";
};